import module_aebdffe5c6e143808c057e75268856ff from '../includes/glsl-compat.vert'
var fn = function( obj ){
var __t,__p='';
__p+=''+
(obj.version)+
'\n\n'+
(module_aebdffe5c6e143808c057e75268856ff())+
'\n\nIN vec3 aPosition;\nIN vec2 aTexCoord;\nIN vec4 aSeeds;\nOUT vec2 vTexCoord;\n\nuniform mat4 uMVP;\nuniform float uTime;\n\nvoid main(void){\n\n  vec3 position = vec3(aPosition.x, 0.0, aPosition.y);\n  position.x += aPosition.z * 0.5;\n\n  vec2 cycle = 0.5 + 0.5 * sin(aSeeds.xy * 10.0 + uTime * (0.25 + aSeeds.zw * 0.25));\n  float phase = (cycle.x + cycle.y) * 0.5;\n  // float phase = 0.5 + 0.5 * sin(aSeeds.y * 10.0 + uTime * (0.25 + aSeeds.y * 0.25));\n  position.z += mix(-4.0, -8.0, phase);\n\n  \n  gl_Position = uMVP * vec4(position, 1.0);\n  vTexCoord = (aTexCoord - vec2(0.5)) * 2.0;\n}';
return __p;
};
fn.toString=fn;
export default fn;
fn._hmrListeners = []
fn.onHmr = function(l){
  this._hmrListeners.push( l )
}
fn._triggerHmr = function(){
  for (const l of this._hmrListeners) {
    l( this )
  }
}

if( import.meta.hot ){
  if( import.meta.hot.data && import.meta.hot.data._hmrListeners ){
    fn._hmrListeners = import.meta.hot.data._hmrListeners;
    fn._triggerHmr()
  }
  
  import.meta.hot.dispose(data => {
    data._hmrListeners = fn._hmrListeners;
  });
  
  import.meta.hot.accept(
    function(e){} // Function to handle errors when evaluating the new version
  );
}
